import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import Form from '../components/FormBlock';
import CardsComponent from '../components/CardsComponent';
import VideoComponent from '../components/VideoComponent';
import Icon from '../Icon/Icon';
import axios from 'axios';
import { useLanguage } from '../components/LanguageContext';

const HomePage = () => {
  const [teamImages, setTeamImages] = useState({});
  const { language, translations } = useLanguage();
  const location = useLocation();

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const serverBaseUrl = process.env.REACT_APP_SERVER_BASE_URL || 'http://localhost:5000';
        const res = await axios.get(`${serverBaseUrl}/api/team-images`);
        const imagesMap = res.data.reduce((acc, item) => {
          acc[item.member] = item.imageUrl;
          return acc;
        }, {});
        setTeamImages(imagesMap);
      } catch (error) {
        console.error('Помилка завантаження зображень:', error);
      }
    };
    fetchImages();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const getImageUrl = (member) => teamImages[member] || '';
  const t = translations['translations.json']?.home || {};

  const renderTextWithStyles = (text) => {
    if (!text) return null;
    const keywords = ['Education', 'Experience', 'Languages', 'Location'];
    return text.split('\n').map((line, index, array) => {
      const parts = line.split(new RegExp(`(${keywords.join('|')})`, 'g')).map((part, i) => {
        if (keywords.includes(part)) {
          return <span key={i} style={{ fontWeight: 700 }}>{part}</span>;
        }
        return part;
      });
      return (
        <React.Fragment key={index}>
          {parts}
          {index < array.length - 1 && <br />}
        </React.Fragment>
      );
    });
  };

  return (
    <div className="content_container">
      <Nav />
      <div className="container">
        <div className="home_container">
          <p className="home_title">{t.title?.[language]}</p>
          <VideoComponent />
        </div>
        <div className="about_home-container">
          <p className="about_home-title">{t.about?.title?.[language]}</p>
          <div className="about_home-item">
            <p className="about_home-descr">{renderTextWithStyles(t.about?.description?.[language])}</p>
            <Link className="about_link" to="/about">{t.about?.more_link?.[language]}</Link>
          </div>
        </div>
        <div className="home_team-container">
          <div className="page_header">
            <h1>{t.team?.title?.[language]}</h1>
          </div>
          <div className="grid_container">
            <div className="grid_item">
              <img src={getImageUrl('oleksandra')} alt="Oleksandra Misiats" />
              <Link to='/team'><p>{t.team?.members?.oleksandra_misiats?.name?.[language]}</p></Link>
              <span>{t.team?.members?.oleksandra_misiats?.role?.[language]}</span>
            </div>
            <div className="grid_item">
              <img src={getImageUrl('kristina')} alt="Kristina Kamardina" />
              <Link to='/team'><p>{t.team?.members?.kristina_kamardina?.name?.[language]}</p></Link>
              <span>{t.team?.members?.kristina_kamardina?.role?.[language]}</span>
            </div>
            <div className="grid_item">
              <img src={getImageUrl('yurii')} alt="Yurii Shapoval" />
              <Link to='/team'><p>{t.team?.members?.yurii_shapoval?.name?.[language]}</p></Link>
              <span>{t.team?.members?.yurii_shapoval?.role?.[language]}</span>
            </div>
            <div className="grid_item">
              <img src={getImageUrl('polina')} alt="Polina Frishko" />
              <Link to='/team'><p>{t.team?.members?.polina_frishko?.name?.[language]}</p></Link>
              <span>{t.team?.members?.polina_frishko?.role?.[language]}</span>
            </div>
          </div>
          <div className="home_text-team">
            <p>{renderTextWithStyles(t.team?.description?.[language])}</p>
            <Link to="/team">{t.team?.get_in_touch_link?.[language]}<img src={Icon.arrowIconW} alt="GET IN TOUCH" /></Link>
          </div>
        </div>
        <CardsComponent />
        <div className="home_desrc-us">
          <h1>{t.why_choose_us?.title?.[language]}</h1>
          <div className="descr_us-container">
            <div className="us-item">
              <p className="us_item-title">{t.why_choose_us?.items?.transparency?.title?.[language]}</p>
              <p className="us_item-descr">{renderTextWithStyles(t.why_choose_us?.items?.transparency?.description?.[language])}</p>
            </div>
            <div className="us-item">
              <p className="us_item-title">{t.why_choose_us?.items?.comprehensive_approach?.title?.[language]}</p>
              <p className="us_item-descr">{renderTextWithStyles(t.why_choose_us?.items?.comprehensive_approach?.description?.[language])}</p>
            </div>
            <div className="us-item">
              <p className="us_item-title">{t.why_choose_us?.items?.international_expertise?.title?.[language]}</p>
              <p className="us_item-descr">{renderTextWithStyles(t.why_choose_us?.items?.international_expertise?.description?.[language])}</p>
            </div>
            <div className="us-item">
              <p className="us_item-title">{t.why_choose_us?.items?.time_efficiency?.title?.[language]}</p>
              <p className="us_item-descr">{renderTextWithStyles(t.why_choose_us?.items?.time_efficiency?.description?.[language])}</p>
            </div>
            <div className="us-item">
              <p className="us_item-title">{t.why_choose_us?.items?.expert_guidance?.title?.[language]}</p>
              <p className="us_item-descr">{renderTextWithStyles(t.why_choose_us?.items?.expert_guidance?.description?.[language])}</p>
            </div>
          </div>
        </div>
        <Form />
        <Footer />
      </div>
    </div>
  );
};

export default HomePage;